import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";
import { api } from "@/lib/api";

const KEY = "ao-theme-v2";
const listeners = new Set();

export const getTheme = () => (localStorage.getItem(KEY) === "light" ? "light" : "dark");

export function applyTheme(t) {
  document.documentElement.classList.toggle("light", t === "light");
  document.documentElement.classList.toggle("dark", t === "dark");
  localStorage.setItem(KEY, t);
  listeners.forEach((fn) => fn(t));
}

export function useTheme() {
  const [t, setT] = useState(getTheme);
  useEffect(() => { listeners.add(setT); return () => { listeners.delete(setT); }; }, []);
  return t;
}

export function ThemeToggle({ className = "" }) {
  const t = useTheme();
  const next = t === "light" ? "dark" : "light";
  const toggle = () => { applyTheme(next); api.put("/me/theme", { theme: next }).catch(() => {}); };
  return (
    <button type="button" data-testid="theme-toggle" onClick={toggle} aria-label={next === "dark" ? "Tema escuro" : "Tema claro"} title={next === "dark" ? "Tema escuro" : "Tema claro"}
      className={`h-9 w-9 inline-flex items-center justify-center rounded-md text-zinc-400 hover:text-amber-brand hover:bg-zinc-900 ${className}`}>
      {t === "light" ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
    </button>
  );
}
